import { create } from 'apisauce';
import axiosRetry from 'axios-retry';
import { SSO_API_URL, DEFAULT_TIMEOUT } from './constants';
import { camelizeKeys, decamelizeKeys } from '~/utils/humps';

const authApi = create({
  baseURL: SSO_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
  timeout: DEFAULT_TIMEOUT,
});

axiosRetry(authApi.axiosInstance, {
  retries: 3,
  retryCondition: error => axiosRetry.isNetworkError(error),
  retryDelay: (...args) => axiosRetry.exponentialDelay(...args),
});

authApi.addRequestTransform(req => {
  if (req.headers) {
    req.headers.XHR = true;
    req.headers.Authorization = '';
  }
  if (req.data) {
    req.data = decamelizeKeys(req.data);
  }
});

authApi.addResponseTransform(req => {
  if (req.data) {
    req.data = camelizeKeys(req.data);
  }
});

export default authApi;
